import { render, staticRenderFns } from "./ScanCN22.vue?vue&type=template&id=1f06691d&scoped=true&"
import script from "./ScanCN22.vue?vue&type=script&lang=js&"
export * from "./ScanCN22.vue?vue&type=script&lang=js&"
import style0 from "./ScanCN22.vue?vue&type=style&index=0&id=1f06691d&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f06691d",
  null
  
)

export default component.exports